module.exports = __webpack_public_path__ + "img/portfolio.7ca94e4f.png";